import { useRef } from "react";
import SEO from "../SEO/SEO";
import "./landing.css";

export default function Landing() {
  const stdContainerRef = useRef(null);

  const handleScroll = (event) => {
    event.preventDefault();
    stdContainerRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div>
      <SEO
        title="Location Cure Thermale Châtel-Guyon | Appartements Meublés 4★ & Studios 2★"
        description="Location appartements et studios meublés à Châtel-Guyon pour cure thermale. Appartement 4 étoiles 38m² et studio 2 étoiles 19m², à 3min des Thermes Aïga. Réservation 06 95 39 85 19"
        canonical="https://chatel-guyon-hotel-cure-thermes.fr/"
      />
      <section id="landing">
        <div className="presentation-box">
          {" "}
          <h1 className="visually-hidden">
            Location Appartements et Studios Cure Thermale Châtel-Guyon
          </h1>{" "}
          <h2>Bienvenue à la résidence du Grand Hôtel à Châtel-Guyon !</h2>
          <p>
            Profitez d’un <strong>emplacement exceptionnel</strong> en plein
            centre-ville, à seulement 3 minutes à pied des nouveaux Thermes Aïga
            et à proximité immédiate des commerces, restaurants, théâtre et
            casino.
          </p>
          <p>
            Nous vous proposons deux logements tout confort :
            <ul>
              <li>
                <strong>Appartement 4 étoiles de 38 m²</strong> avec balcon,
                parking privé (sur demande) et vue sur le parc, idéal pour un
                séjour thermal ou touristique.
              </li>
              <li>
                <strong>Studio 2 étoiles de 19 m²</strong>, parfait pour les
                voyageurs en solo ou en couple.
              </li>
            </ul>
            Chaque hébergement est équipé de tout le nécessaire pour rendre
            votre séjour agréable et pratique.
          </p>
          <p>
            <strong>
              Réservez dès maintenant pour vivre une expérience unique à
              Châtel-Guyon !
            </strong>
          </p>
        </div>
      </section>
      <div className="arrow-down-container">
        <a
          href="#std-container"
          onClick={handleScroll}
          aria-label="Défiler vers les logements"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="currentColor"
            className="size-6"
            width="240"
            height="240"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="m4.5 5.25 7.5 7.5 7.5-7.5m-15 6 7.5 7.5 7.5-7.5"
            />
          </svg>
        </a>
      </div>
      {/* Placez ce div à l'endroit où vous souhaitez scroller */}
      <div id="std-container" ref={stdContainerRef} className="scroll-anchor" />
    </div>
  );
}
